import { useEffect, useState } from 'react';
import {
  Box,
  MenuItem,
  Stack,
  Typography,
} from '@mui/material';
import CustomModal from 'src/components/modal/customModal';
import { styled, useTheme } from '@mui/material/styles';
import FormProvider, { RHFCheckbox, RHFMultiCheckbox, RHFRadioGroup, RHFSelect, RHFTextField } from 'src/components/hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, Controller } from 'react-hook-form';
import { renderErrorMessage, renderSuccessMessage } from 'src/lib/toastMessage';
import { axiosGetCall,  axiosPostCall } from 'src/services/apisCall';
import { VOICE } from 'src/lib/Enums';
import { checkButtonAccess } from 'src/utils/common';
import { jwtDecode } from 'jwt-decode';
import Logger from 'src/lib/Logger';
const logger = new Logger('voiceHostAdd');

const InputContainer = styled('div')(() => ({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  gap: '20px',
}));
const FieldHeading = styled(Typography)(() => ({
  fontWeight: 500,
}));

const AddHost = ({ openModal, handleCloseModal, title, forceLoad, updateUserId}) => {
  const [canSubmit, setCanSubmit] = useState(true);
  const [hostDetails, setHostDetails] = useState({});

  const { email } = jwtDecode(localStorage.getItem('token'));

  const { ROUTE } = VOICE;
  const theme = useTheme();

  const Schema = Yup.object().shape({
    route: Yup.string().required('Route is required!'),
    ownerId: Yup.string().required('Owner ID is required!'),
    token: Yup.string().required('Token is required!'),
    portUrl: Yup.string().required('Port URL is required!'),
    speedPerMinute: Yup.string().required('Speed per minute is required!'),
    rabbitMqHost: Yup.string().required('RabbitMQ host is required!'),
    rabbitMqPort: Yup.string().required('RabbitMQ port is required!'),
    rabbitMqUser: Yup.string().required('RabbitMQ user is required!'),
    rabbitMqPass: Yup.string().required('RabbitMQ password is required!'),

  });

  const methods = useForm({
    resolver: yupResolver(Schema),
    defaultValues: {
      route: '',
      ownerId: '',
      token: '',
      portUrl: '',
      speedPerMinute: '',
      rabbitMqHost: '',
      rabbitMqPort: '',
      rabbitMqUser: '',
      rabbitMqPass: '',  
    },
  });

  const { control, watch, setValue, handleSubmit, reset, formState: { errors } } = methods;

  // Count total validation errors
  const totalErrors = Object.keys(errors).length;

  const onSubmit = async(data) => {
    setCanSubmit(false);
  try{
    const payload = {
      route: data.route,
      ownerId: data.ownerId,
      token: data.token,
      postUrl: data.portUrl,
      speedPerMinute: data.speedPerMinute,
      rabbitMqHost: data.rabbitMqHost,
      rabbitMqPort: data.rabbitMqPort,
      rabbitMqUser: data.rabbitMqUser,
      rabbitMqPass: data.rabbitMqPass,
    };
      if (updateUserId) {
        payload.hostId = updateUserId,
        payload.adminEmail = email;
        await axiosPostCall('updateHost', payload);
      } else{
        await axiosPostCall('addVoiceHost', payload);
      }

    renderSuccessMessage(updateUserId ? 'Host updated successfully' : 'Host added successfully');
    handleCloseModal();
    reset();
    forceLoad(true);

  } catch (error) {
    logger.error('Add Gateway [handleSubmit]', error);
    const errorMessage = error?.message;
    renderErrorMessage(errorMessage);
  } finally {
    setCanSubmit(true);
  }
  };

  const onCancel = () => {
    reset ();
  };

useEffect(() => {
  if (updateUserId) {
    const fetchGatewayList = async () => {
      try {
        const { hostList } = await axiosGetCall("getVoiceHostList", { search: updateUserId });
        console.log("Host List", hostList[0].route);
        setHostDetails(hostList[0]);
      } catch (error) {
        // logger.error("Gateway List", error);
        renderErrorMessage(error?.message);
      }
    };

    fetchGatewayList();
  } else {
     setHostDetails({});
  }
}, [updateUserId]);



useEffect(() => {
  if (hostDetails) {
    setValue('route', hostDetails?.route);
    setValue('ownerId', hostDetails?.owner_id);
    setValue('token', hostDetails?.token);
    setValue('portUrl', hostDetails?.post_url);
    setValue('speedPerMinute', hostDetails?.speed_per_minute);
    setValue('rabbitMqHost', hostDetails?.rabbit_mq_host);
    setValue('rabbitMqPort', hostDetails?.rabbit_mq_port);
    setValue('rabbitMqUser', hostDetails?.rabbit_mq_user);
    setValue('rabbitMqPass', hostDetails?.rabbit_mq_pass);
  }
}, [hostDetails]);



  const description = (
    <Box>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Stack
          direction="column"
          gap={2}
          sx={{ p: '25px', overflowY: 'auto', maxHeight: '600px', height: '100%', width: '800px' }}
        >
            <InputContainer>
            <RHFSelect name="route" label="Route" control={control}>
              {ROUTE.map((ele) => (
                <MenuItem key={ele.value} value={ele.value}>
                  {ele.label}
                </MenuItem>
              ))}
            </RHFSelect>
            </InputContainer>
            <InputContainer>
            <RHFTextField name="ownerId" label="Owner ID" placeholder="Enter Owner ID." />
            </InputContainer>
            <InputContainer>
            <RHFTextField name="token" label="Token" placeholder="Enter Token." />
            </InputContainer>
            <InputContainer>
            <RHFTextField name="portUrl" label="Port URL" placeholder="Enter Port URL." />
            </InputContainer>
            <InputContainer>
            <RHFTextField type = "number" name="speedPerMinute" label="Speed Per Minute" placeholder="Enter Speed Per Minute." />
            </InputContainer>
            <InputContainer>
            <RHFTextField name="rabbitMqHost" label="Rabbit MQ Host" placeholder="Enter Rabbit MQ Host." />
            </InputContainer>
            <InputContainer>
            <RHFTextField name="rabbitMqPort" label="Rabbit MQ Port" placeholder="Enter Rabbit MQ Port." />
            </InputContainer>
            <InputContainer>
            <RHFTextField name="rabbitMqUser" label="Rabbit MQ User" placeholder="Enter Rabbit MQ User." />
            </InputContainer>
            <InputContainer>
            <RHFTextField name="rabbitMqPass" label="Rabbit MQ Pass" placeholder="Enter Rabbit MQ Pass." />
            </InputContainer>
            
        

            {/* {checkButtonAccess("addsmsgateway", "w") && (        */}

          <Box sx={{ display: 'flex', gap: '1rem', mt: 3 }}>
            <Box
              sx={{
                width: '7.625rem',
                backgroundColor: canSubmit ? '#212B36' : 'grey',
                borderRadius: '8px',
                p: '0.562rem',
                height: '2.375rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                pointerEvents: canSubmit ? 'auto' : 'none',
              }}
              onClick={handleSubmit(onSubmit)}
            >
              <Typography sx={{ fontWeight: 600, color: '#fff' }}>
                {updateUserId ? "Update" : "Submit"}
                </Typography>
            </Box>
            <Box
              sx={{
                width: '7.625rem',
                backgroundColor: '#fff',
                borderRadius: '8px',
                p: '0.562rem',
                height: '2.375rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
              }}
              onClick={onCancel}
            >
              <Typography sx={{ fontWeight: 600, color: '#212B36' }}>Cancel</Typography>
            </Box>
          </Box>
            {/* )} */}

        </Stack>
      </FormProvider>
    </Box>
  );

  return (
    openModal && (
      <CustomModal
        open={openModal}
        title={updateUserId ? "Update Voice Host" : "Add New Voice Host"}
        description={description}
        close={handleCloseModal}
        isCloseIcon={true}
      />
    )
  );
};

export default AddHost;
